import axios from 'axios';

// API URL from environment variable — set REACT_APP_API_URL in .env
// Falls back to prod if not set (safe default)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.focusview.ai';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const articleAPI = {
  getAllArticles: (params) => api.get('/articles', { params }),
  getMixedFeed: (page = 0, perCategory = 10) => api.get('/articles/feed', { params: { page, per_category: perCategory } }),
  getArticleById: (id) => api.get(`/articles/${id}`),
  getArticlesByCategory: (category, limit = 20) => api.get('/articles', { params: { category, limit } }),
  getBreakingNews: (params) => api.get('/articles/breaking', { params }),
  searchArticles: (params) => api.get('/articles/search', { params }),
  getRecommendations: (id, params) => api.get(`/articles/${id}/recommendations`, { params }),
};

export const trendingAPI = {
  getTrendingTopics: (params) => api.get('/trending/topics', { params }),
};

export const categoryAPI = {
  getCategories: () => api.get('/categories'),
};

export default api;